<template>	
	<div class="w-full">
		<vs-row vs-justify="center">
			<vs-col  vs-type="flex" vs-justify="center" vs-w="6 " vs-sm="12" class="text-left">
				<Default :index="index" :label="$t('MODULE.typeSelector')"></Default>
			</vs-col>
		</vs-row>
		<h6 class="vs-input--label mb-3 mt-5">{{$t('MODULE.addOptionsTolist')}}</h6>
		<Options :index="index"></Options>
	</div>
</template>
<script type="text/javascript">	
	import Options from '../../componentsToQuestions/Options.vue';
	import Default from '../../componentsToQuestions/DefaultSelect.vue';
	import { mapState } from 'vuex';

	export default {
		props: ['index'],
		components: { Options, Default },
		
		computed: {
			...mapState('resource',['questionsByPage']),
		}
	}
	
</script>